import React from 'react'

const MapIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M6.83301 9.5L3.83301 8.45L1.50801 9.35C1.34134 9.41667 1.18717 9.39792 1.04551 9.29375C0.903841 9.18958 0.833008 9.05 0.833008 8.875V1.875C0.833008 1.76667 0.864258 1.67083 0.926758 1.5875C0.989258 1.50417 1.07467 1.44167 1.18301 1.4L3.83301 0.5L6.83301 1.55L9.15801 0.65C9.32467 0.583333 9.47884 0.602083 9.62051 0.70625C9.76217 0.810417 9.83301 0.95 9.83301 1.125V8.125C9.83301 8.23333 9.80176 8.32917 9.73926 8.4125C9.67676 8.49583 9.59134 8.55833 9.48301 8.6L6.83301 9.5ZM6.33301 8.275V2.425L4.33301 1.725V7.575L6.33301 8.275ZM7.33301 8.275L8.83301 7.775V1.85L7.33301 2.425V8.275ZM1.83301 8.15L3.33301 7.575V1.725L1.83301 2.225V8.15Z' />
  </svg>
)

export default MapIcon
